import * as React from 'react'

import { cn } from './utils'

export const isFieldFilled = (value: unknown) => {
  if (value == null) return false
  if (typeof value === 'string') return value.length > 0
  if (typeof value === 'number') return !Number.isNaN(value)
  if (value instanceof Date) return !Number.isNaN(value.getTime())
  return true
}

export const InFieldLabel = ({
  children,
  floated,
  htmlFor,
  startContent,
  invalid,
  multiline,
  className,
}: {
  children: React.ReactNode
  floated: boolean
  htmlFor?: string
  startContent?: boolean
  invalid?: boolean
  multiline?: boolean
  className?: string
}) => (
  <span
    id={htmlFor ? `${htmlFor}-label` : undefined}
    className={cn(
      'pointer-events-none absolute z-10 origin-left transition-all duration-200 ease-out',
      startContent ? 'left-10' : 'left-4',
      floated
        ? 'top-3 translate-y-0 text-[11px] leading-none text-muted-foreground'
        : multiline
          ? 'top-3.5 text-sm font-normal text-foreground/70'
          : 'top-1/2 -translate-y-1/2 text-sm font-normal text-foreground/70',
      invalid && 'text-destructive',
      className
    )}
  >
    {children}
  </span>
)

export const inFieldShellClass = ({
  variant = 'default',
  multiline,
}: {
  variant?: 'default' | 'ghost'
  multiline?: boolean
} = {}) =>
  cn(
    'relative w-full',
    variant === 'ghost' ? 'input-ghost' : 'input-style',
    multiline ? 'min-h-[7rem]' : 'min-h-14'
  )
